module.exports = " <div class=\"l-wrapper \">\n    <div class=\"c-grid-two-columns\">\n        <search-user (searchCifEmitter)=\"searchByCif($event)\" class=\"c-grid-two-columns__column\"></search-user>\n        <!--<create-user (createUserEmitter)=\"createUser($event)\" class=\"c-grid-two-columns__column\"></create-user>-->\n    </div>\n    <users-list [users]=\"results\"></users-list>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/users/templates/main-users.html
// module id = ./src/app/modules/users/templates/main-users.html
// module chunks = main